<div
  class="settings-wrapper flexlayout justify-space-between"
  [ngClass]="sidenavCollapsed ? 'collapsed-box' : 'extended-box'"
  (click)="menuTrigger.openMenu()"
  >
  <mat-icon>settings</mat-icon>
  @if (!sidenavCollapsed) {
    <span>{{ 'sidenav.settings' | translate }}</span>
  }
  <div #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu"></div>
</div>

<mat-menu #menu="matMenu">
  @if ((authenticated | async)?.admin) {
    <button mat-menu-item>
      <a [href]="adminToolPath" target="_blank">
        <mat-icon>admin_panel_settings</mat-icon>
        <span>{{ 'sidenav.administration' | translate }}</span>
      </a>
    </button>
  }
  <button mat-menu-item [matMenuTriggerFor]="languageSelector">
    <mat-icon>language</mat-icon>
    <span>{{ 'sidenav.language' | translate }}</span>
  </button>
  <button mat-menu-item (click)="goToAlertSettings()">
    @if (alertsConfigured) {
      <mat-icon>notification_important</mat-icon>
    }
    @if (!alertsConfigured) {
      <mat-icon>notifications_off</mat-icon>
    }
    <span>{{ 'sidenav.alerts' | translate }}</span>
  </button>
  <button mat-menu-item [routerLink]="['/data-protection']">
    <mat-icon class="material-icons-outlined">privacy_tip</mat-icon>
    <span>{{ 'sidenav.privacyPolicy' | translate }}</span>
  </button>
  <button mat-menu-item [routerLink]="['/disclaimer-page']">
    <mat-icon class="material-icons-outlined">privacy_tip</mat-icon>
    <span>{{ 'sidenav.disclaimer' | translate }}</span>
  </button>
  <button mat-menu-item [routerLink]="['/credits-page']">
    <mat-icon class="material-icons-outlined">privacy_tip</mat-icon>
    <span>{{ 'sidenav.credits' | translate }}</span>
  </button>
  <button mat-menu-item [routerLink]="['/contact-page']">
    <mat-icon class="material-icons-outlined">mail</mat-icon>
    <span>{{ 'sidenav.contactPage' | translate }}</span>
  </button>
  <button mat-menu-item [routerLink]="['/app-info']">
    <mat-icon>info</mat-icon>
    <span>{{ 'app.version' | translate }}</span>
  </button>
</mat-menu>

<mat-menu #languageSelector="matMenu">
  @for (language of languages; track language) {
    <button mat-menu-item (click)="updateLanguage(language)">
      {{ language.name }}
    </button>
  }
</mat-menu>
